import request from "@/utils/request.js";
// 护士加app-天使vip会员

/**
 * 获取会员用户基础信息
 * @param params
 * @returns {AxiosPromise}
 */
export function getAngelVipUserBaseInfo(params) {
  return request({
    url: "/userService/api/app/angel/vip/getAngelVipUserBaseInfo",
    method: "post",
    data: params
  });
}

export function getSuperVipUserBaseInfo(params) {
  return request({
    url: '/userService/api/app/angel/vip/getSuperVipUserBaseInfo',
    method: 'post',
    data: params
  })
}
export function getAngelVipUserBaseInfoAll(params) {
  return request({
    url: "/userService/api/app/angel/vip/getAngelVipUserBaseInfoAll",
    method: "post",
    data: params
  });
}